import React from 'react';

import DecentText from '~/components/patterns/typography/DecentText';

import {
	useUserAgentsQuery,
} from './UserAgentHeaderValue.gql';

import {
	UserAgent,
} from '~/model/websites/userAgents';


import {
	UserAgentFieldsScope
} from '~/components/app/UserAgentFields';



function usePrefetch() {
	return useUserAgentsQuery();
}


type Props = {
	userAgent?: UserAgent | null,
	customHeaderValue?: string | null,
	isUserAgentBranded: boolean,
	userAgentOptions?: ReadonlyArray<{
		readonly headerValue: string,
		readonly isBranded: boolean,
		readonly type: string,
	}> | null,
	scope: UserAgentFieldsScope,
	useNewCrawlerIdentity?: boolean,
};

const UserAgentHeaderValue: React.FC<Props> = (props) => {
	const {
		customHeaderValue = null,
		userAgent: userAgentType = null,
		isUserAgentBranded,
		userAgentOptions,
		scope,
		useNewCrawlerIdentity = false,
	} = props;

	const fetchUserAgentParams = scope === UserAgentFieldsScope.Website
		? {
			variables: {
				isUserAgentBranded,
				useNewCrawlerIdentity,
			},
		}
		: undefined;
	const { data } = useUserAgentsQuery(fetchUserAgentParams);

	if (userAgentType === UserAgent.Custom) {
		return (
			<DecentText>
				{customHeaderValue}
			</DecentText>
		);
	}

	const userAgent = userAgentOptions?.find((agent) => agent.type === userAgentType)
		|| data?.userAgents.find((agent) => agent.type === userAgentType);

	if (!userAgent) {
		return null;
	}

	const headerValue = userAgent.headerValue;

	return (
		<DecentText>
			{headerValue}
		</DecentText>
	);
};



export default UserAgentHeaderValue;

export {
	usePrefetch,
};
